/*@flow*/
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useEffect } from 'react';
import useDownload from './useDownload';
import { useToaster } from 'lib/toast';
import usePrev from 'lib/usePrev';
import Blank from 'lib/Blank';
import flash from 'lib/flash';

export default function useDownloadToaster(): {|
  isLoading: boolean,
  scheduleDownload: (query: { ... }) => void,
|} {
  const { scheduleDownload, downloadErrors, isLoading } = useDownload();
  const errors = downloadErrors;
  const prevLoading = usePrev(isLoading);
  const { slowToast, closeToaster } = useToaster();

  useEffect(() => {
    if (isLoading) {
      slowToast(
        <span className="mr-2">
          Your download will automatically start when ready{' '}
        </span>
      );
    } else if (prevLoading) {
      closeToaster();
    }
  }, [prevLoading, isLoading]);

  useEffect(() => {
    if (Blank.is(errors)) return;
    flash('Error downloading your file.');
  }, [errors]);

  return { scheduleDownload, isLoading };
}
